import * as types from '../types';
const userWorkbookUpdated = (workbookId, userWorkbook) => ({
  type: types.USER_WORKBOOK_UPDATED,
  userWorkbook,
  workbookId
});
export default userWorkbookUpdated;